export class DWDeletePayRequest
{
    Token:string='';
    sessionID:string='';
}